import React, { useState } from 'react';
import { Activity, FileText, Globe, Plug } from 'lucide-react';

const TABS = [
  { key: 'quotes', label: 'Quotes', icon: FileText },
  { key: 'queue', label: 'Production Queue', icon: Activity },
  { key: 'stores', label: 'Storefronts', icon: Globe },
  { key: 'integrations', label: 'Integrations', icon: Plug },
];

const Row = ({ left, mid, right, tone = 'slate' }) => {
  const tones = { slate: 'bg-slate-800 text-slate-300', emerald: 'bg-emerald-500/15 text-emerald-300', amber: 'bg-amber-500/15 text-amber-300', indigo: 'bg-indigo-500/15 text-indigo-300', cyan: 'bg-cyan-500/15 text-cyan-300' };
  return (
    <div className="flex min-w-0 items-center justify-between gap-3 rounded-lg border border-slate-800/80 bg-slate-950/60 px-3 py-2.5 text-xs">
      <span className="shrink-0 font-mono text-slate-400">{left}</span>
      <span className="min-w-0 flex-1 truncate text-slate-200">{mid}</span>
      <span className={`shrink-0 rounded-md px-2 py-0.5 font-mono text-[10px] uppercase tracking-wider ${tones[tone]}`}>{right}</span>
    </div>
  );
};

const PANELS = {
  quotes: [
    ['Q-1042', 'Lincoln HS Volleyball · 48 tees, 2-color front', 'Sent', 'indigo'],
    ['Q-1041', 'Northside Brewing · 120 hoodies, embroidered', 'Approved', 'emerald'],
    ['Q-1039', 'Summit Realty · 36 polos, left chest', 'Awaiting art', 'amber'],
    ['Q-1038', 'Ridge Festival · 500 DTF event shirts', 'Paid', 'emerald'],
  ],
  queue: [
    ['PRESS 1', 'Northside Brewing · burn screens → print', 'In progress', 'cyan'],
    ['EMB 2', 'Summit Realty · 12-needle · 7,400 stitches', 'Staged', 'amber'],
    ['DTF', 'Ridge Festival · 500 transfers · cure 15s', 'Queued', 'slate'],
    ['FINISH', 'Lincoln HS · fold, bag, pack slip', 'Ready', 'emerald'],
  ],
  stores: [
    ['LIVE', 'northsidemerch.com · custom domain · SSL', 'Primary', 'emerald'],
    ['LIVE', 'summit.yourplatform.com · subdomain', 'Fallback', 'indigo'],
    ['DRAFT', 'lincolnvb.yourplatform.com · team store', 'Setup', 'amber'],
    ['LIVE', 'ridgefest.com · event storefront', 'Primary', 'emerald'],
  ],
  integrations: [
    ['SANMAR', 'Catalog + live inventory', 'Connected', 'emerald'],
    ['S&S', 'Wholesale pricing feed', 'Connected', 'emerald'],
    ['STRIPE', 'Card payments · deposits · balances', 'Connected', 'emerald'],
    ['SHIPPO', 'Labels + tracking emails', 'Connected', 'emerald'],
  ],
};

export const HeroDashboard = () => {
  const [tab, setTab] = useState('quotes');
  return (
    <div data-testid="hero-dashboard" className="relative min-w-0 max-w-full overflow-hidden rounded-2xl border border-slate-800 bg-slate-900/80 p-4 shadow-2xl shadow-indigo-950/40 backdrop-blur-md">
      <div className="pointer-events-none absolute -inset-px rounded-2xl bg-[radial-gradient(60%_40%_at_20%_0%,rgba(79,70,229,.25),transparent)]" />
      <div className="relative flex flex-wrap gap-1 rounded-xl bg-slate-950/70 p-1">
        {TABS.map(({ key, label, icon: Icon }) => (
          <button key={key} type="button" data-testid={`hero-tab-${key}`} onClick={() => setTab(key)}
            className={`inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-medium transition-colors ${tab === key ? 'bg-indigo-600 text-white' : 'text-slate-400 hover:text-slate-200'}`}>
            <Icon size={13} /> {label}
          </button>
        ))}
      </div>
      <div className="relative mt-3 grid gap-2">
        {PANELS[tab].map(([l, m, r, t]) => <Row key={l + m} left={l} mid={m} right={r} tone={t} />)}
      </div>
      <div className="relative mt-3 grid grid-cols-3 gap-2 text-center">
        {[['$48.2k', 'Open quotes'], ['17', 'Jobs on floor'], ['3.1d', 'Avg. turnaround']].map(([v, l]) => (
          <div key={l} className="rounded-lg border border-slate-800/80 bg-slate-950/60 py-2.5">
            <div className="font-mono text-lg font-semibold text-slate-50">{v}</div>
            <div className="text-[10px] uppercase tracking-widest text-slate-500">{l}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
